import React from 'react';
import analyticsLib from '@nerdwallet/analytics';
import { ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import ChevronLeft from '@nerdwallet/react-icon/material/ChevronLeft';
import ChevronRight from '@nerdwallet/react-icon/material/ChevronRight';
import { Text, Accent } from '@nerdwallet/currency';
import classNames from 'classnames';
import styles from '../comparison-grid.module.less';
import { EVENT_TYPES, ENTITY_NAME, ACTION, INTERACTION_TYPE, DIRECTION } from '../../lib/analytics-constants';
export var getPaginationEntities = function getPaginationEntities(_ref) {
  var paginationItemIndex = _ref.paginationItemIndex,
      maxEntitiesToShow = _ref.maxEntitiesToShow,
      shouldEnableAddEntity = _ref.shouldEnableAddEntity,
      totalEntities = _ref.totalEntities,
      updatePaginationItemIndex = _ref.updatePaginationItemIndex;
  var upperBound = paginationItemIndex + maxEntitiesToShow; // should not be able to paginate left/right if at the boundaries

  var disablePaginateLeft = paginationItemIndex === 0;
  var disablePaginateRight = upperBound === totalEntities; // show the add card feature only at the end of the list

  shouldEnableAddEntity(upperBound === totalEntities);
  var leftButtonClasses = classNames([styles.compareGridPaginationButton, disablePaginateLeft && styles.disabled]);
  var rightButtonClasses = classNames([styles.compareGridPaginationButton, disablePaginateRight && styles.disabled]);

  var trackPaginationOnClick = function trackPaginationOnClick(impressionId, direction) {
    analyticsLib.track(EVENT_TYPES.ELEMENT_INTERACTED, {
      action: ACTION.SELECT,
      entity_name: "".concat(ENTITY_NAME.COMPARISON_GRID_NAVIGATE, "_").concat(direction),
      interaction_type: INTERACTION_TYPE.PRESS,
      impression_id: impressionId
    });
  };

  var paginatePrevious = function paginatePrevious(impressionId) {
    if (disablePaginateLeft) {
      return;
    }

    trackPaginationOnClick(impressionId, DIRECTION.LEFT);
    updatePaginationItemIndex(paginationItemIndex - 1);
  };

  var paginateNext = function paginateNext(impressionId) {
    if (disablePaginateRight) {
      return;
    }

    trackPaginationOnClick(impressionId, DIRECTION.RIGHT);
    updatePaginationItemIndex(paginationItemIndex + 1);
  };

  var paginationText = /*#__PURE__*/React.createElement("div", {
    className: styles.compareGridPaginationText
  }, /*#__PURE__*/React.createElement(Text, {
    inline: true
  }, "Viewing "), /*#__PURE__*/React.createElement(Accent, {
    inline: true
  }, paginationItemIndex + 1, "-", Math.min(totalEntities, upperBound)), /*#__PURE__*/React.createElement(Text, {
    inline: true
  }, " of "), /*#__PURE__*/React.createElement(Accent, {
    inline: true
  }, totalEntities));

  var leftArrow = function leftArrow(impressionContext) {
    return /*#__PURE__*/React.createElement(ElementInteraction, {
      elementCategory: "select",
      elementName: "".concat(ENTITY_NAME.COMPARISON_GRID_NAVIGATE, "_").concat(DIRECTION.LEFT),
      id: "".concat(ENTITY_NAME.COMPARISON_GRID_NAVIGATE, "_").concat(DIRECTION.LEFT),
      type: "CLICK"
    }, /*#__PURE__*/React.createElement("span", {
      onClick: function onClick() {
        return paginatePrevious(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
      }
    }, /*#__PURE__*/React.createElement(ChevronLeft, {
      className: leftButtonClasses,
      size: 24
    })));
  };

  var rightArrow = function rightArrow(impressionContext) {
    return /*#__PURE__*/React.createElement(ElementInteraction, {
      elementCategory: "select",
      elementName: "".concat(ENTITY_NAME.COMPARISON_GRID_NAVIGATE, "_").concat(DIRECTION.RIGHT),
      id: "".concat(ENTITY_NAME.COMPARISON_GRID_NAVIGATE, "_").concat(DIRECTION.RIGHT),
      type: "CLICK"
    }, /*#__PURE__*/React.createElement("span", {
      onClick: function onClick() {
        return paginateNext(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
      }
    }, /*#__PURE__*/React.createElement(ChevronRight, {
      className: rightButtonClasses,
      size: 24
    })));
  };

  return {
    rightArrow: rightArrow,
    leftArrow: leftArrow,
    paginationText: paginationText,
    // hide pagination component if there are maxEntitiesToShow or less cards in the compare grid
    shouldHidePagination: totalEntities <= maxEntitiesToShow
  };
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export var getPaginationPayload = function getPaginationPayload(tabName) {
  return {
    elementImpressionPayload: {
      id: ENTITY_NAME.COMPARISON_GRID_NAVIGATE,
      elementName: ENTITY_NAME.COMPARISON_GRID_NAVIGATE,
      sectionCategory: tabName
    },
    impressionPayload: {
      entityName: ENTITY_NAME.COMPARISON_GRID_NAVIGATE,
      eventType: EVENT_TYPES.ELEMENT_IMPRESSION,
      payload: {
        section_name: tabName
      }
    }
  };
};